import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Button } from '../ui/button';
import { FileText, Lightbulb } from 'lucide-react';

interface SummaryFormProps {
  data: string;
  onChange: (data: string) => void;
}

// Examples removed for clean UI

const SummaryForm: React.FC<SummaryFormProps> = ({ data, onChange }) => {


  const wordCount = data.trim().split(/\s+/).filter(word => word.length > 0).length;
  const charCount = data.length;

  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <FileText className="h-5 w-5" />
          Professional Summary
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="space-y-2">
          <Label htmlFor="summary">
            Professional Summary *
            <span className="text-sm text-gray-500 ml-2">
              ({wordCount} words, {charCount} characters)
            </span>
          </Label>
          <Textarea
            id="summary"
            placeholder=""
            value={data}
            onChange={(e) => onChange(e.target.value)}
            rows={6}
            className="resize-none"
            required
          />
          <div className="flex justify-between text-sm text-gray-500">
            <span>Recommended: 50-150 words</span>
            <span className={wordCount > 150 ? 'text-red-500' : wordCount < 50 ? 'text-yellow-500' : 'text-green-500'}>
              {wordCount < 50 ? 'Too short' : wordCount > 150 ? 'Too long' : 'Good length'}
            </span>
          </div>
        </div>

        {/* Writing Tips */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div className="flex items-start gap-2">
            <Lightbulb className="h-5 w-5 text-blue-600 mt-0.5" />
            <div>
              <h3 className="font-medium text-blue-900 mb-2">Writing Tips</h3>
              <ul className="text-sm text-blue-800 space-y-1">
                <li>• Start with your professional title and years of experience</li>
                <li>• Highlight your most relevant skills and achievements</li>
                <li>• Mention specific technologies, tools, or methodologies you excel in</li>
                <li>• Include quantifiable results when possible (e.g., "increased sales by 25%")</li>
                <li>• End with your career goals or what you bring to potential employers</li>
                <li>• Use action words and avoid first-person pronouns (I, me, my)</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Example Summaries removed */}

        {/* Character Limit Warning */}
        {charCount > 800 && (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
            <p className="text-sm text-yellow-800">
              <strong>Note:</strong> Your summary is quite long ({charCount} characters).
              Consider shortening it to ensure it fits well on your resume and maintains the reader's attention.
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default SummaryForm;